import { cycleCountPlanIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const setCycleCountLineCount = unaryRpc({
  name: "setCycleCountLineCount" as const,
  input: z.object({
    planId: cycleCountPlanIdFormat.schema,
    /** Required when the plan row targets a bin; ignored when it targets a product. */
    productId: productIdFormat.schema.nullish(),
    /** Required when the plan row targets a product; ignored when it targets a bin. */
    storageLocationId: storageLocationIdFormat.schema.nullish(),
    /** Null clears the count, removing the line entirely. */
    finalCount: z.int().min(0).nullish(),
  }),
  output: z.object({}),
});
